import React from "react";
import { getValueElement, printKey } from "./utils";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import TableCompareRowArray from "./TableCompareRowArray";

const TableCompareRow = ({ index, field, oldValues, newValues, action }) => {
  if (["growthGoals", "workedExamples", "lcs"].includes(field)) {
    return (
      <TableCompareRowArray
        field={field}
        oldValues={oldValues}
        newValues={newValues}
        action={action}
      />
    );
  }

  return (
    <TableRow key={`table-columd-body-${field}-${index}`}>
      <TableCell width={100} className="overflow-hidden">
        <Typography
          variant="inherit"
          className="font-bold text-sm"
          color="primary"
        >
          {printKey(field)}
        </Typography>
      </TableCell>
      <TableCell className="overflow-hidden max-w-200px">
        {getValueElement(oldValues[field], field)}
      </TableCell>
      <TableCell className="overflow-hidden max-w-200px">
        {getValueElement(newValues[field], field)}
      </TableCell>
    </TableRow>
  );
};
export default TableCompareRow;
